// extracted by mini-css-extract-plugin
module.exports = {"modal":"ConfigureModal_modal__b_-6O"};